export default {
	termsAndConditions: {
		lastUpdate: 'Ultima actualizare: 10 iunie 2024',
		content: `
		<p>Termenii pe care îi veți găsi mai jos sunt importanți deoarece:</p>
		<ul>
			<li>Aceștia își stabilesc drepturile legale în {siteName}.</li>
			<li>Explicați drepturile pe care ni le acordați atunci când utilizați {siteName}.</li>
			<li>
				Acestea descriu regulile pe care toată lumea trebuie să le respecte atunci când folosește {siteName}.
			</li>
		</ul>
		<p>
			Vă rugăm să citiți cu atenție acești Termeni, precum și {privacyPolicyLink} și orice alții
			documentele menționate în acești Termeni.
		</p>
		<p>Să începem...</p>
		<h3>1. INTRODUCERE ȘI DATE ALE {siteNameUpper}.</h3>
		<p>
			Site-ul web {websiteLink} (denumit în continuare „Site-ul”) este deținut de companie
			{siteName} S.L (denumită în continuare „{siteName}”), O companie
			încorporată în conformitate cu legislația spaniolă cu sediul pe Avenida de
			Cerdanyola, nr. 75, 1º, Sant Cugat del Vallès (Barcelona), deținător al numărului CIF
			B-56.768.260 și înregistrată în Registrul Mercantil din Barcelona în Volum
			49065, Folio 0033, Fila B-606324, Inmatriculare 1.
		</p>
		<p>
			{siteName} vă pune la dispoziție site-ul web, astfel încât să puteți accesa
			cunoaște-ne mai bine, cunoașteți serviciile pe care le oferim și dacă doriți, puteți contacta
			și, după caz, contract cu noi.
		</p>
		<h3>2. SCOPUL ȘI SCOPUL DE APLICARE A TERMENILOR DE UTILIZARE</h3>
		<p>
			Aceste condiții de utilizare constituie, împreună cu {privacyPolicyLink} și
			{cookiesPolicyLink}, cadrul legal care reglementează utilizarea site-ului web
			{Link-ul}. Aceste condiții de utilizare vă vor fi disponibile pe site
			în limba engleză pentru a le putea consulta, arhiva sau tipări oricând și
			oricand vrei.
		</p>
		<p>
			Pentru a cunoaște orice întrebare referitoare la tratamentul efectuat de {siteName}.
			a datelor dvs. personale, vă rugăm să vizitați {privacyPolicyLink} și {cookiesPolicyLink}.
			Ambele politici vă vor fi disponibile și în limba engleză, astfel încât să puteți
			consultați-le, arhivați-le sau tipăriți-le în orice moment.<br />
			{siteName} folosește cookie-uri terță parte pe site. Pentru a afla mai multe
			despre tipul de cookie-uri utilizate pe web {websiteLink}, scopul acestora și cum
			pentru a vă configura browserul în cazul în care nu doriți să folosim aceste cookie-uri,
			accesați {cookiesPolicyLink}.
		</p>
		<p>
			Atât aceste condiții de utilizare, cât și {privacyPolicyLink} și 
			{cookiesPolicyLink} au fost pregătite în conformitate cu prevederile actuale
			reglementarile aplicabile, printre altele, Legea 34/2002, privind Serviciile
			Societatea Informațională și Comerțul Electronic și Regulamentul (UE) 2016/679 din
			Parlamentul European și al Consiliului, din 27 aprilie 2016, privind
			protecția persoanelor fizice cu privire la prelucrarea datelor personale
			date și libera circulație a acestor date și prin care Directiva 95/46/CE
			este abrogat.
		</p>
		<h3>3. ACCES LA SITE WEB ȘI ACCEPTARE</h3>
		<p>
			Accesul la Site este gratuit, cu excepția părții legate de costul
			conexiune prin rețeaua de telecomunicații furnizată de internet
			furnizorul de acces pe care l-ați contractat. Puteți naviga liber pe site
			și accesați-l de câte ori doriți. Pentru a accesa și naviga pe site,
			nu trebuie să vă înregistrați, cu excepția cazului în care doriți să angajați un serviciu.
		</p>
		<p>
			Utilizarea site-ului web vă conferă condiția de utilizator al site-ului
			(denumit în continuare „Utilizatorul”) și implică acceptarea deplină și fără rezerve a dvs
			aceste condiții de utilizare, precum și {privacyPolicyLink} și {cookiesPolicyLink}
			a site-ului web. În plus, sunteți de acord să nu utilizați Serviciul în scopuri ilegale
			scopuri.
		</p>
		<p>
			Accesând site-ul și navigând pe acesta, declarați sub dvs
			responsabilitatea că sunteți major și că aveți legalitatea necesară
			capacitatea de a accesa site-ul web și de a-l utiliza, declarând, de asemenea, că sunteți pe deplin
			înțelegeți și acceptați aceste condiții de utilizare fără rezerve.
		</p>
		<p>
			Pe de altă parte, vă informăm că din motive legale arhivăm
			documente electronice în care sunt formalizate achizițiile. Puteți accesa
			aceste documente în orice moment, solicitându-le la: {supportLink}.
		</p>
		<h3>4. CONDIȚII DE UTILIZARE A SITE-ULUI WEB</h3>
		<p>
			Utilizatorul este de acord să folosească site-ul web în conformitate cu aceste condiții de utilizare,
			legislatia actuala si buna-credinta. Astfel, Utilizatorul va răspunde la {siteName}.
			 și în fața oricărui terț pentru daunele și pierderile rezultate din
			folosirea contrară acestor condiții, legislației și bunei-credințe făcute
			de către Utilizatorul Site-ului.
		</p>
		<h3>5. DESCRIEREA SERVICIULUI</h3>
		<p>
			Prin intermediul Serviciului, {siteName} permite abonamentul la serviciu
			efectuați editarea imaginilor.
		</p>
		<p>
			Limba în care este încheiat contractul dintre {siteName} și cumpărător
			se va incheia va fi cea a tarii de origine.<br />
			Procesul de achiziție în serviciul online va fi următorul:
		</p>
		<ol>
			<li>Trebuie să vă înregistrați pe site cu un nume de utilizator și o parolă.</li>
			<li>
				În momentul înregistrării, utilizatorul trebuie să selecteze unul dintre planurile de plată
				gasite in sectiunea Preturi si li se vor acorda credite in functie de
				planul ales. Fiecare credit vă va permite să editați o imagine.
			</li>
			<li>
				După achiziționarea serviciului, utilizatorul va avea o administrare
				panou unde vor găsi:
				<ul>
					<li>
						O secțiune cu o listă a tuturor imaginilor care au fost procesate, fiind
						puteți să-l editați de câte ori doriți și să îl descărcați pe dvs
						dispozitiv.
					</li>
					<li>
						O secțiune din Planuri și plăți pentru a consulta facturile și a anula
						abonament.
					</li>
					<li>O secțiune a Contului meu pentru a putea schimba preferințele contului.</li>
				</ul>
			</li>
		</ol>
		<p>
			Odată ce achiziționarea serviciului a fost efectuată, acesta va fi confirmat de
			trimiterea unui email, in termen de maxim 24 de ore, la adresa pe care o ai
			indicat. Acesta va indica serviciul, cum să anulați abonamentul, acesta
			suma, taxele aplicabile, forma de plată și condițiile aplicabile și
			conditii.
		</p>
		<h4>Abonament 5.1</h4>
		<p>
			Abonamentul la serviciu variază în funcție de planul selectat și va fi
			reînnoit automat pentru aceeași perioadă de timp până la încetarea acestuia.
			Dacă nu vă anulați abonamentul, ne autorizați să încărcăm
			taxa anuală de abonament corespunzătoare în metoda dvs. de plată.
		</p>
		<p>
			Vă puteți anula oricând abonamentul la Serviciu și o veți face
			continuați să aveți acces la acesta până la sfârșitul perioadei anuale de facturare. La
			în măsura permisă de lege, plățile sunt nerambursabile și nu oferim
			rambursări sau credite pentru perioade parțiale de abonament anual.
		</p>
		<h3>6. PREȚ ȘI TAXE</h3>
		<p>
			Prețurile produselor oferite pe {siteName} sunt indicate în euro
			(€) sau moneda țării din care se face achiziția, Valoarea
			Taxa adăugată (TVA) în vigoare la momentul achiziției se percepe asupra prețului
			produse.
		</p>
		<p>
			În orice caz, operațiunea ar putea fi scutită sau nu supusă TVA în funcție de
			țara de reședință sau starea în care acționați. Din acest motiv,
			în unele cazuri prețul final al comenzii poate fi modificat în raport cu
			unul afișat.<br />
			Achizițiile efectuate de subiecții scutiți de plata TVA vor indica acest lucru prin
			trimițând numărul lor de TVA/NIF prin e-mail la {supportLink}, fără înregistrare
			achiziții cu taxa respectivă.
		</p>
		<h3>7. METODĂ DE PLATĂ</h3>
		<p>
			Plata online a serviciului achiziționat se poate face cu card de credit sau debit.
			În acest sens, {siteName} informează deținătorii de carduri de credit și de debit că
			tranzacțiile din magazinul online sunt efectuate printr-o plată securizată
			gateway, folosind tehnologia SSL pentru a garanta securitatea transmiterii datelor.
		</p>
		<h3>8. DREPTUL DE RETRAGERE ȘI DE RAMBURĂRI</h3>
		<h4>8.1. Dreptul de retragere</h4>
		<p>
			Având în vedere tipul de produs comercializat în serviciul nostru online, software în format digital
			format QR, dreptul de retragere nu va fi aplicabil conform
			articolul 103, lit. m) din Decretul Legislativ Regal 1/2007, din 16 noiembrie, de
			că textul revizuit al Legii generale pentru apărarea consumatorilor și
			Utilizatorii și alte legi complementare sunt aprobate.
		</p>
		<h4>8.2. Rambursări</h4>
		<p>
			Indiferent de planul ales de utilizator, sumele plătite de utilizator și către
			măsura permisă de lege nu va fi rambursabilă.
		</p>
		<p>
			Serviciul contractat nu poate fi atribuit sau transferat altor utilizatori ai
			serviciul.
		</p>
		<p>
			În orice caz, utilizatorul poate face uz de serviciul contractat până la sfârșitul
			perioada contractata.
		</p>
		<h3>9. VALABILITATEA OFERTELOR</h3>
		<p>
			Serviciile oferite în Serviciu și prețurile acestora vor fi disponibile pentru
			cumpără cât se află în catalogul de servicii afișate prin aceasta
			site-ul web.
		</p>
		<p>
			În orice caz, {siteName} își rezervă dreptul de a face modificări
			consideră potrivit în Serviciu, putând actualiza produsele și serviciile
			in functie de piata.
		</p>
		<p>
			{siteName} își rezervă dreptul de a modifica prețurile fără notificare prealabilă. Noi
			vă informăm că, în ciuda actualizărilor care se fac la prețurile la
			Service, ar putea conține erori. Vom corecta prompt orice erori care
			apar, dar nu vor fi obligatorii pentru Serviciu.
		</p>
		<h3>10. SIGURANȚĂ</h3>
		<p>
			După cum sa indicat mai sus, întreaga procedură de cumpărare, precum și transmiterea
			a datelor dumneavoastră personale și a sistemelor de plată, se realizează pe o pagină securizată și
			într-un mod criptat prin protocolul SSL.
		</p>
		<p>
			Garantăm securitatea Serviciului în conformitate cu actuala
			cunoștințe tehnologice. Cu toate acestea, {siteName} nu poate garanta totalitatea
			securitatea viitoare a Serviciului. În orice caz, promitem să corectăm și
			implementează măsurile corective adecvate pentru a corecta o eventuală securitate
			încălcarea cât mai curând posibil.
		</p>
		<p>
			Sunteți de acord să notificați {siteName}, imediat și prin e-mail {supportLink}
			a oricărei situații care ar putea duce la uzurparea identității unui utilizator.
		</p>
		<h3>11. MODIFICARI SI NULITATE</h3>
		<p>
			Putem actualiza și termenii și condițiile Serviciului în viitor
			ca caracteristicile și funcțiile Serviciului însuși.
		</p>
		<p>
			Vă vom informa cu privire la modificările termenilor și condițiilor prin plasarea unei notificări
			într-un loc vizibil pe site-ul nostru web și/sau prin e-mail.
		</p>
		<p>
			Dacă vreo clauză inclusă în acești termeni și condiții este declarată, în totalitate sau
			parțial, nul sau ineficient, acesta va afecta doar prevederea sau partea respectivă
			din aceasta care este nulă sau ineficientă. Termenii și condițiile vor exista
			orice altceva, având o astfel de prevedere, sau partea din ea care este afectată, de
			nefiind plasat.
		</p>
		<h3>12. RECENTII SI ACTIUNI DERIVATE DIN CONTRAC</h3>
		<p>
			Pe cât posibil, acest Serviciu este guvernat de legea spaniolă.<br />
			În vederea simplificării soluţionării pretenţiilor prin procedura civilă şi
			reduce costurile, nu excludem posibilitatea de a ne supune unui
			Arbitrajul echitabil al Curții de Arbitraj a Camerelor de Comerț și
			Industrie. În acest sens, și conform reglementărilor aplicabile,
			 {siteName} informează despre existența unei soluții online europene a litigiilor
			platformă care facilitează soluționarea extrajudiciară a unor astfel de dispute pt
			contracte încheiate și online între consumatori și servicii de internet
			furnizorii. Această platformă poate fi accesată pe următorul site:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. DREPTURILE DE PROPRIETATE INTELECTUALĂ ȘI INDUSTRIALĂ</h3>
		<p>
			Site-ul web și conținutul său sunt supuse protecției în aplicarea
			reglementarile nationale actuale privind Proprietatea Intelectuala si/sau Industriala, as
			precum şi în aplicarea convenţiilor internaţionale aplicabile în astfel de
			contează. {siteName} este proprietarul sau a licențiat în mod corespunzător tuturor
			Drepturi de proprietate intelectuală și industrială asupra site-ului și a conținutului acestuia.
		</p>
		<p>
			Orice formă de reproducere, distribuție, comunicare publică, transformare,
			punerea la dispoziție și, în general, orice alt act de exploatare indiferent dacă este sau nu
			in scopuri comerciale ale Site-ului sau continutului acestuia, fara prealabil
			consimțământul expres al {siteName}. Este interzisă în mod expres ștergerea
			datele de identificare ale lui {siteName} ca proprietar al intelectualului și
			Drepturile de proprietate industrială ale site-ului web sau ale conținutului acestuia.
		</p>
		<p>
			{siteName} își rezervă toate drepturile de proprietate intelectuală și industrială
			asupra site-ului și a conținutului acestuia, rezervându-se, de asemenea, exercitarea oricăror legi
			acțiunile care îi corespund în vederea încetării, împiedicării sau urmăririi penale
			utilizarea ilicită a site-ului web sau a conținutului acestuia. În niciun caz și sub nr
			circumstanțe face accesul la Website sau utilizarea acestuia de către Utilizator sau terți
			părțile constituie sau implică o cesiune de orice fel de către {siteName} a
			drepturile de proprietate intelectuală sau industrială ale site-ului web sau ale conținutului acestuia.
			În niciun caz, lipsa cerinței de către {siteName} de a înceta utilizarea
			Site-ul web sau conținutul său ilegal sau contrar acestor condiții pot fi
			înțeles ca un consimțământ tacit al {siteName} pentru astfel de utilizări sau ca o renunțare
			a exercitării oricărei acțiuni în justiție care i-ar putea corespunde.
		</p>
		<h3>14. RESPONSABILITĂȚI ȘI GARANȚII</h3>
		<p>
			Utilizatorul trebuie să utilizeze site-ul web și conținutul acestuia în conformitate cu
			prevederile prezentelor conditii de utilizare, legislatia in vigoare si buna-credinta. Orice
			utilizarea site-ului web sau a conținutului acestuia contrar acestor condiții generale
			legea sau buna-credinta este interzisa in mod expres, indiferent daca respectiva utilizare are
			un scop economic sau nu.<br />
			Utilizatorul va fi responsabil pentru orice daune sau prejudicii cauzate {siteName}
			 sau către terți derivate direct sau indirect din orice utilizare
			pe care Utilizatorul face din Site-ul sau conținutul acestuia contrar acestora
			conditiile, legea, morala, ordinea publica sau buna-credinta.
		</p>
		<p>
			Pentru ca site-ul web și conținutul acestuia să fie accesibile utilizatorului, {siteName}
			 necesită servicii furnizate de terți. Este posibil ca
			în ciuda eforturilor depuse de {siteName} pentru a menține site-ul disponibil
			și accesibilă utilizatorilor, disponibilitatea acestuia poate fi suspendată, întreruptă sau
			anulat din motive dincolo de {siteName}. De aceea {siteName}
			nu garantează absența întreruperilor sau erorilor în accesarea
			Site-ul web sau conținutul acestuia, nici că acestea sunt actualizate sau afișate întotdeauna în
			ultima lor versiune. În consecință, {siteName} refuză orice
			răspunderea pentru daunele care pot fi cauzate Utilizatorului sau terților ca
			ca urmare a suspendării, întreruperii, lipsei de continuitate, întreruperii rețelei
			sau deconectarea site-ului.
		</p>
		<p>
			În niciun caz și sub nicio circumstanță {siteName} nu va fi responsabil pentru
			daune sau pierderi derivate utilizatorului din cauze neimputabile {siteName}
			 precum, cu titlu de exemplu și în niciun caz limitativ, natural
			dezastre, situații de forță majoră sau urgență extremă, viruși, nocivi
			componente, disfuncționalități ale browserului, căderi de rețea, intruziuni în computer sau
			atacuri de la terți.
		</p>
		<h3>15. LINK-URI</h3>
		<p>
			Site-urile web, platformele, forumurile, chaturile, blogurile sau rețelele sociale externe care
			link-ul sau link-ul către site-ul web trebuie să informeze în mod clar că nu au
			autorizarea sau supravegherea {siteName} și respectiva legătură sau
			linkul nu implică, presupune sau implică asociere de niciun fel între {siteName}
			 și site-urile web, platformele, forumurile, chaturile, blogurile sau externe
			rețelele de socializare care conectează sau conectează la site-ul web.
		</p>
		<p>
			În orice caz, orice link care este destinat Site-ului trebuie direcționat
			direct la pagina de pornire sau pagina de pornire a site-ului web făcând clic pe adresa URL
			a site-ului web care acoperă întregul ecran al paginii de pornire sau al paginii de început a
			Site-ul, astfel încât linkul să fie absolut și complet fără utilizarea
			cadre, cadre sau hyperlinkuri. {siteName} nu răspunde în niciun caz
			și în orice circumstanță la conținutul, informațiile sau datele legate de
			site-ul web, conținutul acestuia sau orice altă chestiune conținută în site-uri web, platforme,
			forumuri, chat-uri, bloguri sau rețele sociale terțe care fac link sau link la
			Site-ul web.
		</p>
		<p>
			Este interzisă în mod expres crearea de link-uri sau link-uri către site de pe site-uri web,
			platforme, forumuri, chat-uri, bloguri sau rețele sociale contrare legii, moravurilor
			si bune obiceiuri, mai ales cele cu pornografie, ilicite, ilegale sau
			conținut care încalcă drepturile omului.
		</p>
		<p>
			Pe de altă parte, site-ul web poate conține link-uri către site-uri web ale terților,
			platforme, forumuri, chat-uri, bloguri sau rețele sociale. {siteName} nu
			dispune de mijloacele umane și/sau tehnice pentru a cunoaște sau controla informațiile și
			conținut care apare pe site-urile web ale terților. Prin urmare, în niciun caz nu va {siteName}
			 să fie responsabil pentru conținutul site-urilor legate și sub nr
			circumstanțele respectivele legături pot fi considerate cunoaștere efectivă a conținutului
			a site-urilor către care se leagă.
		</p>
		<h3>16. PROTECȚIA DATELOR</h3>
		<p>
			După cum este stabilit în {privacyPolicyLink}, {siteName} se angajează să folosească Utilizatorul
			datele, să le respecte confidențialitatea și să le utilizeze în conformitate cu
			scopul tratamentului, precum și pentru a-și respecta obligația de a-l salva.
			și să adapteze toate măsurile pentru a evita modificarea, pierderea, tratamentul sau neautorizat
			accesul în conformitate cu prevederile legislației în vigoare privind
			protectia datelor cu caracter personal.
		</p>
		<p>
			Site-ul web încorporează măsuri de protecție adecvate și folosește standardul din industrie
			tehnologie pentru a îmbunătăți securitatea, integritatea, completitudinea, acuratețea și
			protecția datelor cu caracter personal pe care le-a colectat și pe care le-a stabilit
			măsuri de precauție rezonabile pentru a proteja acele informații de o posibilă pierdere sau
			abuz. Regulile sale privind protecția și securitatea datelor sunt revizuite periodic
			și îmbunătățit atunci când este necesar și se străduiește să se asigure că numai autorizat
			persoanele pot accesa informațiile furnizate de Utilizator.
		</p>
		<p>
			Pentru a afla mai multe despre gestionarea și tratamentul efectuat de {siteName}
			 a datelor dvs., vă rugăm să citiți {privacyPolicyLink} și {cookiesPolicyLink}.
		</p>
		<h3>17. DURATA SI MODIFICARE</h3>
		<p>
			Aceste condiții de utilizare vor fi în vigoare atâta timp cât sunt expuse
			utilizatorilor, astfel încât de îndată ce sunt modificați sau actualizați total sau parțial,
			aceste conditii vor inceta sa mai fie in vigoare, fiind noile conditii de utilizare
			cele care continuă să reglementeze utilizarea site-ului web.
		</p>
		<p>
			{siteName} își rezervă dreptul de a le revizui, modifica sau actualiza
			conditii de utilizare in orice moment. În cazul oricărei modificări a acestor condiții
			de utilizare din orice motiv, {siteName} va anunța utilizatorii de pe pagina de pornire despre
			web despre circumstanțele menționate, astfel încât să fie informați corespunzător și să se poată consulta
			revizuirile, modificările sau actualizările prezentelor condiții de utilizare la
			satisfacția ta.
		</p>
		<h3>18. GENERAL</h3>
		<p>
			În nici un caz și sub nicio circumstanță nu va putea lipsi exercițiul drepturilor dumneavoastră
			prin {siteName} să fie înțeles ca o renunțare la acestea.
		</p>
		<p>
			Titlurile cuprinse în aceste condiții sunt doar orientative sau
			informative, astfel încât să nu afecteze, să califice sau să extindă interpretarea
			a acestuia.
		</p>
		<p>
			În cazul în care oricare dintre clauzele cuprinse în aceste condiții au fost
			declarat nul, abuziv sau inaplicabil, total sau parțial, de către o instanță
			sau organ administrativ, respectiva declarație va afecta individual clauza
			în cauză, luându-l ca nu și fără declararea de nulitate, abuz sau
			inaplicabilitatea fiind extinsă în orice împrejurare la restul
			condiţii, care vor subzista.
		</p>
		<p>
			Aceste condiții de utilizare, precum și {privacyPolicyLink} și {cookiesPolicyLink}
			sunt guvernate de reglementările spaniole actuale în orice moment.
		</p>
		<h3>19. SERVICIUL CLIENȚI</h3>
		<p>
			Pentru orice clarificare, incident sau reclamație, ne puteți contacta prin:<br />
			E-mail: {supportLink}<br />
			Adresa postala: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spania.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Ultima actualizare: 10 iunie 2024',
		content: `
			<h3>1. Parte responsabilă și descriere</h3>
			<h5>1.1. Responsabil</h5>
			<p>Persoana responsabilă pentru tratarea acestui site este Remove Background S.L (denumită în continuare Remove Background 
			sau Serviciul), cu adresa la Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spania.</p>
			<p>NIF: B56768260<br> E-mail: {supportLink}</p>

			<h5>1.2. Descriere</h5>
			<p>Acceptarea politicii de confidențialitate a Eliminați fundalul (denumită în continuare „Politica de confidențialitate”) este o condiție necesară 
				pentru utilizarea site-ului nostru web și furnizarea serviciului (denumit în continuare „Serviciul”).<br>
				Această Politică de confidențialitate reglementează colectarea, tratarea și utilizarea informațiilor dumneavoastră personale și non-personale 
				ca utilizator de Eliminare fundal, de la data intrării în vigoare care apare în antet.<br>
				Pentru a vă prelucra datele personale, Remove Background respectă legislația locală și europeană actuală, 
				precum și reglementările sale de aplicare.</p>


			<h3>2. Informații colectate</h3>
			<p>Accesul la site-ul nostru web se poate face fără a fi nevoie de a furniza nicio informație, deși pentru a vă înregistra și/ 
				sau contractați planurile noastre, va trebui să ne furnizați câteva informații personale. Informațiile (personale 
				sau nepersonale) colectate de Serviciu pot varia în funcție de aceasta.<br>
				Informațiile personale și non-personale colectate de Serviciu vor ajunge la noi în trei moduri: 1) ceea ce 
				este colectat automat 2) ceea ce ne furnizați în mod voluntar și 3) ceea ce este furnizat de terți.</p>

			<h5>2.1. Cel colectat automat</h5>
			<p>Aceste informații vor consta în:</p>
			<ul>
				<li>Cel colectat prin cookie-uri sau mecanisme similare stocate pe dispozitivul dvs., întotdeauna cu acordul dvs. sau în 
					în conformitate cu alte baze legale. Consultați Politica noastră privind cookie-urile pentru mai multe informații.</li>
				<li>IP-ul de la care se realizează conexiunea, tipul de dispozitiv utilizat și caracteristicile acestuia, versiunea 
					sistemul de operare, tipul de browser, limba, data, țara, ora solicitării, 
					adresa URL de la care veniți, adresa URL la care mergeți sau rețeaua mobilă utilizată, printre altele.</li>
				<li>Datele de utilizare a serviciului și posibilele erori detectate în timpul utilizării acestuia.</li>
				<li>În plus, Remove Background folosește Google Analytics, un serviciu analitic oferit de Google, LLC. 
					domiciliat în Statele Unite, cu sediul la 1600 Amphitheatre Parkway, Mountain View, California 94043. 
					Pentru furnizarea acestor servicii, aceștia folosesc cookie-uri care colectează informații, inclusiv adresa IP a utilizatorului, 
					care vor fi transmise, prelucrate și stocate de Google în termenii stabiliți pe web www.google.com. 
					Inclusiv posibila transmitere a acestor informații către terți din motive de cerință legală sau 
					atunci când respectivele părți terțe procesează informațiile în numele Google.</li>
			</ul>
			<p>În orice caz, puteți dezactiva cookie-urile Google Analytics de <a href="{externalLink: disableGoogleAnalyticsLink}">aici</a>.</p>

			<h5>2.2. Cel pe care îl furnizați în mod voluntar</h5>
			<p>Aceste informații vor consta în:</p>
			<ul>
				<li>Toate datele sunt obligatorii.</li>
				<li>Cel cerut de Eliminare fundal pentru a vă finaliza înregistrarea pe web: nume și prenume, adresă și e-mail, printre altele.</li>
				<li>Toate datele sunt obligatorii.</li>
				<li>Informațiile, personale sau nu, pentru a finaliza contractarea serviciului, cum ar fi adresa dvs. de e-mail și numărul cardului dvs. de credit sau de debit.</li>
				<li>Informațiile, personale sau nu, pe care le pot conține mesajele trimise prin canalele de contact sau de opinie stabilite în Serviciu, 
					de exemplu, numele și adresa dvs. de e-mail.</li>
			</ul>

			<h5>2.3. Cel furnizat de terți</h5>
			<p>Aceste informații vor consta în:</p>
			<ul>
				<li>Cel furnizat de sistemele de plată sau procesatorii de carduri de credit, cum ar fi momentul achiziției sau suma acesteia.</li>
			</ul>


			<h3>3. Drepturi și scopuri</h3>
			<p>Vă informăm că completarea formularelor este voluntară. Cu toate acestea, dacă nu completați câmpurile obligatorii 
				(marcate de obicei cu un asterisc), utilizarea unor funcții ale Serviciului nu va fi posibilă sau va fi limitată.<br>
				Datele personale pe care ni le furnizați vor fi încorporate și prelucrate în Registrul Activităților de Tratament al Eliminare fundal 
				pentru a putea răspunde solicitărilor dumneavoastră, a furniza serviciul solicitat și a vă ține la curent cu chestiuni legate de activitate 
				a companiei și a serviciilor acesteia.<br>
				Vă puteți exercita în orice moment drepturile de acces, rectificare, ștergere, limitare a tratamentului dumneavoastră, 
				opoziția și portabilitatea datelor dumneavoastră cu caracter personal prin e-mail adresat la: {supportLink} sau la adresa poștală: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spania.<br>
				În ambele cazuri, trebuie să vă identificați cu numele și prenumele, precum și o copie a DNI sau a actului de identitate, dacă este necesar.<br>
				În cazul în care ați acordat consimțământul pentru un anumit scop, aveți dreptul să vă retrageți consimțământul în orice moment, 
				fără a afecta legalitatea tratamentului bazat pe consimțământul anterior retragerii acestuia.<br>
				În plus, dacă considerați că există o problemă cu modul în care Eliminați fundalul vă gestionează datele, 
				vă puteți îndrepta reclamațiile către <a href="{knowYourRightsLink}">autoritatea de protecție a datelor</a> care corespunde, fiind <a href="{aepdLink}">Agenția Spaniolă pentru Protecția Datelor</a> 
				cel indicat în cazul Spaniei.</p>


			<h3>4. Vârsta</h3>
			<p>În ceea ce privește utilizarea serviciului online, declarați că sunteți major și că aveți condițiile legale necesare 
				capacitatea de a fi legat de acest acord și de a utiliza site-ul în conformitate cu termenii și condițiile sale, pe care le-ați pe deplin 
				înțelegeți și recunoașteți.<br>
				Declarați că toate informațiile pe care le furnizați pentru a accesa Serviciul, înainte și în timpul utilizării acestuia, sunt adevărate, complete 
				și precis.</p>


			<h3>5. Utilizarea datelor</h3>
			<p>Eliminare fundal va folosi datele colectate pentru:</p>
			<ul>
				<li>Gestionați și actualizați Serviciul (temeiul legal fiind interesul nostru legitim de a menține și păstra Serviciul 
					la zi și în stare bună).</li>
				<li>Adresați-vă întrebărilor pe care le adresați (temeiul legal fiind interesul nostru legitim de a răspunde solicitărilor și 
					îndoielile utilizatorilor noștri).</li>
				<li>Procesați plățile pe care le efectuați (contractul fiind baza legală).</li>
				<li>Oferiți serviciul contractat (contractul fiind baza legală).</li>
				<li>Mențineți securitatea Serviciului, investigați activitățile ilegale, aplicați termenii și condițiile noastre și
					ajuta fortele de securitate ale statului in cadrul eventualelor lor investigatii (temeiul legal fiind al nostru 
					interes legitim în garantarea și menținerea securității Serviciului și a utilizatorilor acestuia).</li>
			</ul>
			<p>Eliminare fundal nu utilizează decizii automate, deși poate genera profiluri de utilizator de bază, 
				temeiul legal fiind interesul nostru legitim în scopuri comerciale și oferirea de oferte personalizate.<br>
				De asemenea, Remove Background poate folosi informațiile utilizatorului sub formă de date agregate și anonime pentru a le arăta terților. 
				De asemenea, puteți partaja statistici și informații demografice despre utilizatori și utilizarea Serviciului cu terți. 
				Dar nimic din toate acestea nu va permite acelor terțe părți să vă identifice personal.</p>

			<h5>5.1. În e-mailuri și formulare de contact</h5>
			<p>Site-ul web are o criptare SSL care permite utilizatorului să-și trimită datele personale în siguranță prin formulare standard de contact.<br>
				Datele personale colectate vor face obiectul unei prelucrări automate și vor fi încorporate în fișierele corespunzătoare 
				a evidenței activităților de prelucrare și al căror proprietar Remove Background este.</p>
			<p>În acest sens:</p>
			<ul>
				<li>Vom primi adresa dvs. IP, care va fi folosită pentru a verifica originea mesajului pentru a vă oferi 
					recomandări (de exemplu, prezentați informațiile în limba corectă) și pentru a detecta eventuale nereguli 
					(de exemplu, posibile încercări de a ataca Serviciul cibernetic), precum și date legate de ISP-ul dvs.</li>
				<li>La fel, ne puteți furniza datele dumneavoastră prin telefon, e-mail și alte mijloace de comunicare indicate.</li>
			</ul>
			<p>În ceea ce privește mijloacele de plată utilizate:</p>
			<ul>
				<li>Furnizorii noștri de servicii de plată care plătesc pentru furnizarea serviciilor noastre sunt cardul de credit sau de debit. 
					În niciun moment Serviciul sau personalul său nu vor avea acces la detaliile bancare (de exemplu, numărul cardului de credit) 
					pe care utilizatorul în calitate de client le va furniza acelor terți.</li>
			</ul>


			<h3>6. Păstrarea datelor</h3>
			<p>Mai jos, sunt indicate pentru cât timp sunt păstrate datele prelucrate de către Serviciu:</p>
			<ul>
				<li>Datele dezagregate vor fi păstrate fără perioadă de ștergere.</li>
				<li>
					Datele clienților vor fi păstrate pentru minimul necesar și pot fi păstrate până la:
					<ul>
						<li>5 ani, conform art. 1964 din Codul civil (acțiuni personale fără termen special).</li>
						<li>6 ani, conform art. 30 din Codul comercial (registre contabile sau facturi, de exemplu).</li>
					</ul>
				</li>
				<li>Datele utilizatorilor vor fi păstrate pentru o perioadă de maximum 12 luni pentru a putea răspunde solicitărilor acestora.</li>
			</ul>


			<h3>7. Date partajate cu terți</h3>
			<p>Există terțe părți care gestionează o parte a Serviciului.<br>
				Eliminarea fundalului impune ca aceștia să respecte această Politică de confidențialitate, după caz, pe lângă faptul că au a lor. Cu toate acestea, Eliminați fundalul nu va fi responsabil pentru respectarea politicii menționate.<br>
				În anumite circumstanțe, Eliminați fundalul poate partaja, utiliza sau păstra cu terțe părți oricare dintre informațiile personale colectate:</p>
			<ul>
				<li>Pentru a furniza Serviciul:</li>
			</ul>
			<p>Furnizorii de servicii care îndeplinesc funcții în numele nostru, cum ar fi servicii de plată, găzduire web, analize de afaceri, servicii pentru clienți sau marketing web. Acești furnizori de servicii pot colecta și avea acces la informațiile necesare pentru îndeplinirea funcțiilor lor, dar nu au voie să partajeze sau să utilizeze informațiile în niciun alt scop.</p>
			<ul>
				<li>Pentru a coopera cu autoritățile competente:</li>
			</ul>
			<p>Dacă considerăm că este necesar în mod rezonabil pentru a îndeplini orice lege, proces legal sau interes legitim. În orice caz, vom furniza doar informațiile strict necesare.</p>


			<h3>8. Măsuri de securitate</h3>
			<p>Remove Background adoptă toate măsurile tehnice și organizatorice necesare pentru
				proteja securitatea și integritatea informațiilor personale și non-personale colectate. 
				Atât împotriva accesului neautorizat, cât și a modificării, pierderii sau distrugerii lui accidentale.<br>
				În orice caz, Remove Background nu poate garanta securitatea absolută a informațiilor colectate, 
				deci trebuie să colaborezi și să folosești bunul simț cu privire la informațiile partajate în orice moment.<br>
				Înțelegeți și recunoașteți că, chiar și după ștergere, informațiile personale și non-personale pot 
				rămân vizibile în cache sau dacă alți utilizatori l-au copiat sau stocat.</p>


			<h3>9. Modificări ale Politicii de confidențialitate</h3>
			<p>Este posibil să actualizăm această Politică de confidențialitate în viitor. Vă vom informa despre modificările acesteia trimițând o notificare la adresa de e-mail furnizată și/sau plasând o notificare într-un loc vizibil pe site-ul nostru.</p>


			<h3>10. Contact</h3>
			<p>Dacă aveți întrebări despre această politică de confidențialitate, contactați-ne la:</p>
			<p>E-mail: {supportLink}<br> 
				Adresa: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spania.</p>
		`
	},
	gdpr: {
		lastUpdate: 'Ultima actualizare: 10 iunie 2024',
		content: `
			<h3>1. Cine este responsabil și cum să-i contactați?</h3>
			<p>Controllerul acestui site este Remove Background S.L cu adresa Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spania.</p>
			<p>Îl puteți contacta prin e-mail la {supportLink}.</p>

			<h3>2. Ce date sunt colectate?</h3>
			<p>
				Colectăm automat date prin cookie-urile pe care le încărcăm pe dispozitivul dvs., inclusiv analize. 
				De asemenea, colectăm IP-ul de la care se realizează conexiunea, tipul de dispozitiv folosit și caracteristicile acestuia, 
				versiunea sistemului de operare, tipul de browser, limba, data, țara, ora solicitării, 
				adresa URL de la care veniți, adresa URL la care mergeți sau rețeaua mobilă utilizată, printre altele.<br>
				În mod voluntar utilizatorul ne furnizează unele informații precum numele și prenumele său, e-mailul sau informațiile bancare 
				pentru a ne putea contacta, a vă înscrie la serviciu sau a cumpăra un abonament.
			</p>

			<h3>3. Pentru ce sunt folosite datele colectate?</h3>
			<p>
				Serviciul va folosi datele colectate, printre altele, pentru a administra și actualiza serviciul, pentru a răspunde solicitărilor dumneavoastră, 
				vă trimitem buletinul nostru informativ și ofertele promoționale prin e-mail, gestionați-vă înregistrarea pe platformă, gestionați și furnizați 
				serviciile legate de abonamentul dvs., procesează plățile pe care le efectuați și emit facturile corespunzătoare, 
				menține securitatea Serviciului, investighează activități ilicite, aplică termenii și condițiile noastre și 
				să ajute forțele și organele de securitate a statului în cadrul eventualelor investigații ale acestora.
			</p>

			<h3>4. Cât timp sunt păstrate?</h3>
			<ul>
				<li>Datele dezagregate vor fi păstrate fără perioadă de ștergere.</li>
				<li>
					Datele clienților vor fi păstrate pentru minimul necesar și pot fi păstrate până la:
					<ul>
						<li>5 ani, conform art. 1964 din Codul civil (acțiuni personale fără termen special).</li>
						<li>6 ani, conform art. 30 din Codul comercial (registre contabile sau factura, de exemplu).</li>
					</ul>
				</li>
				<li>Datele utilizatorilor vor fi păstrate pentru o perioadă de maximum 12 luni pentru a răspunde solicitărilor acestora.</li>
				<li>Datele utilizatorului încărcate de Serviciu pe paginile și profilurile de pe rețelele sociale vor fi păstrate din momentul în care utilizatorul își oferă consimțământul până când îl retrage.</li>
			</ul>

			<h3>5. Care sunt drepturile dumneavoastră ca utilizator?</h3>

			<p>
				Dreptul de acces: Partea afectată va avea dreptul de a obține confirmarea de la operatorul de date dacă 
				sau nu sunt prelucrate date cu caracter personal care o privesc.
			</p>
			<p>
				Dreptul de rectificare: partea afectată va avea dreptul de a obține, fără întârzieri nejustificate, de la operatorul de date 
				rectificarea datelor cu caracter personal care sunt inexacte și care îl afectează în mod direct. La fel, persoana interesată va 
				au dreptul de a completa datele personale incomplete, inclusiv prin intermediul unei declarații suplimentare.
			</p>
			<p>
				Dreptul de ștergere: Este dreptul părții afectate de a obține, fără întârzieri nejustificate, de la operatorul de date ștergerea 
				a datelor personale care îl privesc.
			</p>
			<p>
				Dreptul la limitarea prelucrării datelor: constă în obținerea limitării prelucrării datelor dumneavoastră de către persoana responsabilă, 
				deși exercitarea acestuia are două aspecte: 1) Când contestați acuratețea datelor dvs. personale, într-o perioadă care permite 
				persoana responsabilă să o verifice și 2) Când v-ați opus prelucrării datelor dumneavoastră cu caracter personal pe care persoana responsabilă 
				desfășoară pe baza unui interes legitim sau a unei misiuni de interes public, în timp ce responsabilul verifică dacă aceste motive 
				prevalează asupra ta.
			</p>
			<p>
				Dreptul la portabilitatea datelor: este dreptul părții afectate de a primi datele personale care o privesc, 
				pe care l-a furnizat unui operator de date, într-un format structurat, de uz comun și citire mecanică și 
				să le transmită altui controlor fără a fi împiedicate de către controlorul căruia i-au fost furnizate.
			</p>
			<p>
				În acest sens, persoana interesată va avea dreptul ca datele cu caracter personal să fie transmise direct de la operator 
				la controlor atunci când este posibil din punct de vedere tehnic.
			</p>

			<h3>6. Cum vă puteți exercita drepturile?</h3>

			<p>
				Vă puteți exercita oricând drepturile asupra datelor personale, trimițând un e-mail la: {supportLink} Sau la adresa poștală: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spania. În ambele cazuri, trebuie să te identifici cu numele și prenumele, 
				precum și o copie a DNI sau a actului de identitate, dacă este necesar.<br>
				În plus, dacă considerați că există o problemă cu modul în care Eliminați fundalul vă gestionează datele, vă puteți direcționa revendicările 
				către <a href="{knowYourRightsLink}">autoritatea de protecție a datelor</a> care corespunde, fiind <a href="{aepdLink}">Agenția Spaniolă pentru Protecția Datelor</a> 
				cel indicat în cazul Spaniei.
			</p>

			<h3>7. Se adoptă măsuri de securitate?</h3>
			<p>
				Serviciul ia toate măsurile tehnice și organizatorice necesare pentru a proteja securitatea și integritatea persoanelor 
				și informații non-personale colectate. Atât împotriva accesului neautorizat, cât și împotriva modificării, pierderii sau distrugerii accidentale.<br>
				În orice caz, Serviciul nu poate garanta securitatea absolută a informațiilor colectate, așa că trebuie să colaborați și 
				folosiți în orice moment bunul simț în ceea ce privește informațiile partajate.<br>
				Înțelegeți și recunoașteți că, chiar și după ștergere, informațiile personale și non-personale pot rămâne vizibile în cache sau 
				dacă este copiat sau stocat de alți utilizatori.
			</p>

			<h3>8. Există transferuri de date personale sau transferuri internaționale?</h3>

			<p>
				Nu transferăm date sau transferuri internaționale. Cu toate acestea, există terțe părți care administrează o parte a Serviciului 
				că trebuie să respectăm Politica noastră de confidențialitate în măsura în care le este aplicabilă și că au propriile lor. 
				Acești terți sunt furnizori de servicii care îndeplinesc funcții în numele nostru, cum ar fi găzduirea web, 
				monitorizarea analizei sau dezvoltarea web.<br>
				De asemenea, dacă considerăm că este necesar în mod rezonabil pentru a satisface orice lege, proces legal sau interes legitim. 
				În orice caz, vom furniza doar informațiile strict necesare.
			</p>

		`
	},
	cookiesPolicy: {
		lastUpdate: 'Ultima actualizare: 21 iunie 2024',
		content: `
			<h3>Rezumat</h3>
			<ul>
			    <li>Cookie-uri utilizate: <strong>proprii și terțe</strong></li>
			    <li>Sunt folosite pentru a obține statistici? <strong>Da, pe baza interesului nostru legitim de a gestiona mai bine serviciul.</strong></li>
			    <li>Servicii terță parte care instalează cookie-uri prin intermediul acestui site web: <strong>Google, Google Analytics, Cloudflare și Stripe.</strong></li>
			</ul>

			<h3>Cum să configurați și să dezactivați modulele cookie</h3>
			<p>
			    Puteți permite, bloca sau șterge cookie-urile instalate pe dispozitivul dvs. din browserul dvs. web. Dacă nu permiteți instalarea cookie-urilor pe dispozitivul dvs., 
			    experiența de navigare se poate înrăutăți. Mai jos, puteți găsi cum să configurați cookie-urile în fiecare browser:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Tipuri și utilizări</h3>
			<p>Serviciul folosește cookie-uri proprii și ale terților pentru a îmbunătăți navigarea, a furniza serviciul și a obține statistici privind utilizarea site-ului web.</p>

			<h3>2. Ce este un cookie și pentru ce este folosit?</h3>
			<p>
			    Un cookie este un fișier text care este trimis către computerul, mobilul sau browserul de pe tabletă și este utilizat pentru a stoca și a prelua informații despre
			    navigarea efectuată. De exemplu, pentru a vă aminti numele de utilizator și parola sau preferințele de profil.
			</p>

			<h3>3. Ce tipuri de cookie-uri există?</h3>
			<p>În funcție de cine le gestionează:</p>
			<ul>
			    <li>Cookie-uri proprii; acestea sunt trimise către browserul dvs. de pe propriile noastre echipamente sau domenii web.</li>
			    <li>Cookie-uri de la terți; acestea sunt trimise către browserul dvs. de la echipamente sau domenii web pe care nu le gestionăm direct, ci de către o terță entitate, cum ar fi Google.</li>
			</ul>
			<p>În funcție de cât timp rămân active, există:</p>
			<ul>
			    <li>Cookie-uri de sesiune; acestea rămân în fișierul cookie al browserului dvs. până când părăsiți site-ul web, așa că niciunul nu rămâne pe dispozitivul dvs.</li>
			    <li>Cookie-uri persistente; acestea rămân pe dispozitivul dvs. și site-ul nostru web le citește de fiecare dată când efectuați o nouă vizită. Aceste cookie-uri nu mai funcționează după o anumită dată.</li>
			</ul>
			<p>În sfârșit, în funcție de scopul lor, avem:</p>
			<ul>
			    <li>Cookie-uri tehnice; acestea îmbunătățesc navigarea și buna funcționare a site-ului.</li>
			    <li>Cookie-uri de personalizare; permit accesul la serviciu cu caracteristici predefinite pe baza unei serii de criterii.</li>
			    <li>Cookie-uri de analiză; permit măsurarea și analiza statistică a utilizării serviciului prestat.</li>
			</ul>
			<p>Lista de cookie-uri terță parte utilizate de <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: cookie-urile lor (NID sau CONSENT) permit personalizarea modului în care apar anunțurile în afara Google sau stocarea informațiilor
			        cum ar fi limba preferată la afișarea rezultatelor căutării.<br><a href="{externalLink: googleCookieTypes}">Mai multe informații</a> despre tipurile de cookie-uri pe care Google le folosește în diferitele sale servicii.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: modulele cookie ale acestora (cum ar fi _ga) permit numărarea de câte ori vizitează un utilizator un site web, cum, când și de unde.<br>
			        În orice caz, puteți dezactiva cookie-urile Google Analytics de <a href="{externalLink: disableGoogleAnalytics}">aici</a>.
			    </li>
			    <li>Cloudflare: pentru a afla despre politica de cookie-uri și utilizarea Cloudflare, faceți clic pe <a href="{externalLink: cloudflareCookiesPolicy}">acest link</a>.</li>
			    <li>Stripe: găsiți informații <a href="{externalLink: stripeCookiesPolicy}">aici</a> despre politica și utilizarea Stripe privind cookie-urile.</li>
			</ul>
		`
	}
};
